import { animate, state, style, transition, trigger } from '@angular/animations';
import {Component, Input, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { FAQ } from '../models/faq';
import { FAQForm } from '../models/faqForm';
import { PortalParameters } from '../models/portalParameters';
import { MessageService } from '../services/message.service';
import { WaitlistService } from '../services/waitlist.service';

@Component({
    selector: 'faq-panel',
    templateUrl: './faq-panel.component.html' ,
    styleUrls: ['./faq-panel.component.scss'],
    animations: [
        trigger('expand', [
            state('open', style({
                height: 'auto',
                opacity:1
            })),
            state('close', style({
                height: '0px',
                opacity:0
            })),
            transition('open=>close', animate('0.2s ease-out')),
            transition('close=>open', animate('0.2s ease-in'))
        ])
    ]
})

export class FAQPanelComponent implements OnInit{

    @Input() selectedForm:string = "";
    faqForm:FAQForm = new FAQForm();
    faqForms:FAQForm[] =[];
    questions:string[] =[];
    allFaqs:FAQ[] = [];
    faqs:FAQ[] = [];
    params: PortalParameters = new PortalParameters();
    imgFolder: string = environment.imgFolder;
    selectedFAQFormID:number = 0;
    isMobile:boolean = false;
    

    constructor (
        private spinnerService: NgxSpinnerService,
        private waitlistService:WaitlistService,
        private msg:MessageService,
        private router:Router,
        private modalService: NgbModal
        ){
            this.isMobile = window.innerWidth < 768;
        }


    ngOnInit()
    {
        this.spinnerService.show();
        this.questions = [];

        this.imgFolder = this.imgFolder + "faq/";
        this.waitlistService.getFAQForms()
        .subscribe(d => {
            this.waitlistService.getFAQs()
            .subscribe(f=>{
                this.allFaqs = f;
                this.faqForms = d;
                //filter only FAQs
                this.faqForms = this.faqForms.filter(f=> f.notes?.toUpperCase().includes('FAQ'));
                this.selectedForm = this.selectedForm && this.selectedForm.length > 0 && (this.faqForms.find(f => f.title.toUpperCase().includes(this.selectedForm.toUpperCase()))?.title?.length ?? 0) > 0 ? this.selectedForm : this.faqForms.find(f => f.displayOrder === 1)?.title ?? "";
                const selectedFormEntry = this.faqForms.find(f =>
                    f.description?.toUpperCase().includes(this.selectedForm.toUpperCase()) ||
                    f.title?.toUpperCase().includes(this.selectedForm.toUpperCase()));
                this.selectedFAQFormID = selectedFormEntry?.faqFormID ?? this.faqForms.find(f => f.displayOrder === 1)?.faqFormID ?? 0;
                this.itemClick(this.selectedFAQFormID);

            });
        }, (err) => {
            this.msg.showError(err, "FAQ Error");
        });  
        this.spinnerService.hide();          
    }


    // ngAfterViewInit (){
    //     if(document.getElementById('close')){
    //         // document.getElementById('close').addEventListener('click', this.closeClick.bind(this));
    //         document.getElementById('close').onclick = (e) => this.closeClick();
    //     }
    // } 


    ngAfterViewChecked (){
        const closeButton = document.getElementById('close');
        if (closeButton) {
            // closeButton.addEventListener('click', this.closeClick.bind(this));
            closeButton.onclick = () => this.closeClick();
        }
    } 

    toggleAccordian(event: Event) {
        var element = event.target as HTMLElement;
        element.classList.toggle("active");
        var panel = element.nextElementSibling as HTMLElement;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = '';
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
    }

    toggleContentAccordian(event: Event) {
        var element = event.target as HTMLElement;
        element.classList.toggle("active");

        var panel = element.nextElementSibling as HTMLElement;
        var parentPanel = element.closest('.panel') as HTMLElement;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = '';
          parentPanel.style.maxHeight = parentPanel.scrollHeight + "px";
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
          parentPanel.style.maxHeight = parentPanel.scrollHeight + panel.scrollHeight + "px";
        }

    }

    contentClose(event: Event){
        var panel = (event.target as HTMLElement).closest('.panel') as HTMLElement;
        panel.style.maxHeight = '';

        var element = panel.previousElementSibling as HTMLElement;
        element.classList.toggle("active");
    }


    goToItem(item:string){
        this.selectedForm = item.replace('Go to ', '');
        const found = this.faqForms.find(f => f.description?.toUpperCase().includes(this.selectedForm.toUpperCase()));
        this.selectedFAQFormID = found?.faqFormID ?? 0;
        this.itemClick(this.selectedFAQFormID);
    }

    gotoPage(pageRoute:string){
        this.router.navigate(['/' + pageRoute]);
        this.closeClick();
    }
    

    itemClick(formID:number){

        //clear searchText
        var searchText = document.getElementById('searchText') as HTMLInputElement;
        if (searchText) searchText.value = "";

        this.faqForm = this.faqForms.find(fr => fr.faqFormID === formID) ?? new FAQForm();
        this.params.faqFormID = formID;
        this.questions = [];

        //set selection
        this.selectedFAQFormID = formID;
        
        this.faqs = this.allFaqs.filter(f=>f.formID === formID);
        this.faqs.forEach(q =>{
                var index = this.questions.indexOf(q.question);
            if (index < 0) 
                this.questions.push(q.question);
        })

    }


    isSelectedRow(formID:number):boolean{
        return this.selectedFAQFormID === formID;
    }


    search(searchText:string): void{

        if (searchText && searchText != "" && searchText.length > 0)
        {
            this.selectedFAQFormID = 0;
            this.faqs = this.allFaqs.filter(f=>f.question.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()) 
                                            || f.answer.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()));
            this.questions = [];
            this.faqs.forEach(q =>{
                    var index = this.questions.indexOf(q.question);
                if (index < 0) 
                    this.questions.push(q.question);
            })
        }
        else {
            const first = this.faqForms.find(f => f.displayOrder === 1);
            this.itemClick(first?.faqFormID ?? 0);
        }
    }

    closeClick(){
        this.selectedForm = "";
        this.modalService.dismissAll();
    }

}